<template>
  <div class="pt-20 overflow-y-auto relative body pb-20">
    <div class="flex justify-center mb-10">
      <div class="relative h-24 w-24">
        <div class="h-24 w-24 bg-cover rounded-full" :style="`background-image: url(${userProfile.profile_image})`"
          v-if="userProfile.profile_image"></div>
        <div class="h-24 w-24 bg-neutral-700 rounded-full flex justify-center items-center" v-else>
          <p
            :class="`font-bold text-3xl text-white ${userProfile?.name !== '' && forInitial(userProfile?.name)?.length > 1 ? '' : 'text-4xl'}`">
            {{ userProfile?.name !== '' ? forInitial(userProfile?.name) : 'A' }}
          </p>
        </div>
        <label for="input-file"
          class="bg-primary-700 p-2 absolute hover:shadow-soft transition-all duration-300 -right-2 bottom-0 w-9 h-9 rounded-full flex justify-center items-center cursor-pointer">
          <Camera />
        </label>
        <input type="file" accept=".jpg, .png, .jpeg" ref="photo" @change="handleFileSelect($event)" class="hidden"
          id="input-file" />
      </div>
    </div>
    <div class="px-6">
      <div class="mb-6">
        <TextField label="Nama Lengkap" v-model="userProfile.name" />
      </div>
      <div class="mb-6">
        <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Jenis Kelamin</label>
        <CustomSelect :options="genderList" v-model="selectedGender" :default="selectedGender"
          placeholder="Pilih jenis kelamin" optionLabel="label" />
      </div>
      <div class="mb-6">
        <TextField label="Alamat Email" disabled v-model="userProfile.email" />
      </div>
      <div class="mb-6">
        <TextField label="No Handphone" v-model="userProfile.phone_number" />
      </div>
      <div class="mb-6">
        Select Account Type
        <div class="flex gap-4">
          <label>
            <input type="radio" name="bank" id="rb_bank" value="bank" v-model="userProfile.account_bank_type" />
            Bank
          </label>
          <label>
            <input type="radio" name="cc" id="rb_cc" value="credit_card" v-model="userProfile.account_bank_type" />
            Credit Card
          </label>
        </div>
      </div>
      <div class="mb-6">
        <TextField label="Pemilik Rekening" v-model="userProfile.account_bank_name" />
      </div>
      <div class="mb-6">
        <TextField label="Nomer Rekening" v-model="userProfile.account_bank_number" />
      </div>
      <div class="mb-6">
        <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Nama Bank</label>
        <CustomSelect :options="bankList" v-model="selectedBank" :default="selectedBank" placeholder="Pilih bank" optionLabel="label" />
      </div>
    </div>
    <div class="px-6 pb-6 bg-white fixed bottom-0 left-0 z-1 w-full">
      <Button buttonText="Update" size="full" @action="update()" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { formatDateTime } from '@/util'
export default {
  filters: {
    formatDateTime
  },
  components: {
    Camera: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/Camera'),
    TextField: () => import('@/components/Forms/TextField'),
    CustomSelect: () => import('@/components/Forms/CustomSelect'),
    Button: () => import('@/components/Forms/Button')
  },
  data() {
    return {
      selectedGender: null,
      selectedBank: null,
      genderList: [
        {
          label: 'Laki-Laki',
          value: 'M'
        },
        {
          label: 'Perempuan',
          value: 'F'
        }
      ],
      bankList: [
        {
          label: 'BCA',
          value: '1'
        },
        {
          label: 'MANDIRI',
          value: '2'
        },
        {
          label: 'BNI',
          value: '3'
        },
        {
          label: 'BRI',
          value: '4'
        },
        {
          label: 'BSI',
          value: '5'
        }
      ],
      image: null
    }
  },
  computed: {
    ...mapGetters('auth', ['userProfile'])
  },
  methods: {
    ...mapActions('auth', ['getProfile', 'updateProfile']),
    ...mapActions('common', ['showLoading', 'hideLoading', 'uploadImage', 'setToast']),
    handleFileSelect(event) {
      this.showLoading()
      let imageData = new FormData()
      imageData.append('image', event.target.files[0])
      imageData.append('file_purpose', 'avatar')
      this.uploadImage({ payloads: imageData }).then(res => {
        this.hideLoading()
        this.userProfile.profile_image = res.file_url
        this.update()
      })
    },
    forInitial: function (name) {
      const arr = name?.split(' ')
      if (arr) {
        let newArr = []
        newArr.push(arr[0].slice(0, 1).toUpperCase())
        if (arr.length > 1) newArr.push(arr[1].slice(0, 1).toUpperCase())
        return newArr.join('')
      }
      return
    },
    getUserProfile() {
      this.getProfile().then(() => {
        this.selectedGender = this.genderList.filter(item => item.value === this.userProfile.gender)[0]
        this.selectedBank = this.bankList.filter(item => item.value === this.userProfile.bank)[0]
        console.log('selectedBank', this.selectedBank)
      })
    },
    update() {
      this.showLoading()
      const payload = {
        name: this.userProfile.name,
        profile_image: this.userProfile.profile_image,
        gender: this.selectedGender.value,
        phone_number: this.userProfile.phone_number || '',
        account_bank_type: this.userProfile.account_bank_type,
        account_bank_name: this.userProfile.account_bank_name,
        account_bank_number: this.userProfile.account_bank_number,
        bank: this.selectedBank.value
      }
      this.updateProfile({ payloads: payload }).then(() => {
        this.hideLoading()
        this.getUserProfile()
      })
    }
  },
  mounted() {
    this.getUserProfile()
  }
}
</script>
<style lang="scss" scoped>
.body {
  height: calc(100% - 52px);
}
</style>